const MEASUREMENT_UNIT_SHIPMENT = 1;
const MEASUREMENT_UNIT_CBM = 24;
const MEASUREMENT_UNIT_WEIGHT = 25;
export const MEASUREMENT_UNIT_CHARGEABLE_WEIGHT = 26;
const MEASUREMENT_UNIT_PER_UNIT = 27;

export type CostLineFormulaInput = {
  quantity?: number | string;
  amount_per_unit?: number | string;
  currency_origin?: string;
  measurement_unit?: number;
  measurement_unit_display?: string;
  weight_unit?: string;
};

export function formatCostLineFormula(item: CostLineFormulaInput): string | null {
  if (!item) return null;
  const quantity = toFiniteNumber(item.quantity);
  const unitAmount = toFiniteNumber(item.amount_per_unit);
  const currency = item.currency_origin;
  const measurementUnit = item.measurement_unit;
  if (quantity === null || quantity <= 0) return null;
  if (unitAmount === null || unitAmount <= 0) return null;
  if (!currency) return null;
  if (measurementUnit === MEASUREMENT_UNIT_SHIPMENT && quantity === 1) return null;

  const qtyText = formatQuantity(quantity, measurementUnit);
  const rateText = unitAmount.toFixed(2);
  const { qtySuffix, rateSuffix } = unitParts(
    measurementUnit,
    item.measurement_unit_display,
    item.weight_unit,
  );
  return `${qtyText}${qtySuffix} x ${rateText} ${currency}${rateSuffix}`;
}

function toFiniteNumber(value: number | string | undefined): number | null {
  if (value === undefined || value === null || value === "") return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  return parsed;
}

export function formatQuantity(quantity: number, measurementUnit?: number): string {
  if (
    measurementUnit === MEASUREMENT_UNIT_WEIGHT ||
    measurementUnit === MEASUREMENT_UNIT_CHARGEABLE_WEIGHT
  ) {
    if (quantity % 1 === 0) return String(quantity);
    return quantity.toFixed(2);
  }
  const text = quantity.toFixed(10).replace(/\.?0+$/, "");
  return text === "-0" ? "0" : text;
}

function compactWeightUnit(unit?: string) {
  const raw = (unit || "kg").trim().toLowerCase();
  if (raw === "lbs" || raw === "lb") return "lbs";
  return "kg";
}

function unitParts(measurementUnit: number | undefined, display?: string, weightUnit?: string) {
  if (measurementUnit === MEASUREMENT_UNIT_CBM) {
    return { qtySuffix: "m³", rateSuffix: "/m³" };
  }
  if (
    measurementUnit === MEASUREMENT_UNIT_WEIGHT ||
    measurementUnit === MEASUREMENT_UNIT_CHARGEABLE_WEIGHT
  ) {
    const compact = compactWeightUnit(weightUnit);
    return { qtySuffix: compact, rateSuffix: `/${compact}` };
  }
  if (measurementUnit === MEASUREMENT_UNIT_PER_UNIT) {
    return { qtySuffix: "", rateSuffix: "/unit" };
  }
  const label = display || "unit";
  return { qtySuffix: "", rateSuffix: `/${label}` };
}
